import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import QuoteModal from '../components/QuoteModal';
import services from '../data/services';

export default function ServiceDetail() {
  const { id } = useParams();
  const [showModal, setShowModal] = useState(false);
  const service = services.find((item) => item.id === id);
  const whatsappUrl = 'https://api.whatsapp.com/send/?phone=919022040062&text=Hello%20i-Sha%20Infosys';

  if (!service) {
    return (
      <section className="container section">
        <div className="empty-state">
          <h1>Service not found</h1>
          <p>The link may be outdated. You can return to the full service list below.</p>
          <Link to="/services" className="btn">
            Back to Services
          </Link>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="page-hero page-hero-compact">
        <div className="container page-hero-inner">
          <span className="eyebrow">{service.category}</span>
          <h1>{service.title}</h1>
          <p>{service.short}</p>
        </div>
      </section>

      <section className="container section">
        <div className="detail-layout">
          <div className="detail-main">
            <div className="detail-image-card">
              <img src={service.image} alt={service.title} className="detail-image" />
            </div>

            <div className="detail-copy-card">
              <h2>What this includes</h2>
              <p>{service.description}</p>

              <div className="detail-section">
                <h3>Key highlights</h3>
                <ul className="bullet-list">
                  {service.highlights.map((highlight) => (
                    <li key={highlight}>{highlight}</li>
                  ))}
                </ul>
              </div>

              <div className="detail-section">
                <h3>Best suited for</h3>
                <p>{service.idealFor}</p>
              </div>
            </div>
          </div>

          <aside className="detail-sidebar">
            <div className="sidebar-panel">
              <span className="eyebrow">Need this service?</span>
              <h3>Let&apos;s plan the right solution for your office.</h3>
              <p>Reach out for a quote, support conversation, or quick project discussion.</p>
              <button className="btn" onClick={() => setShowModal(true)}>
                Request a Quote
              </button>
              <a href={whatsappUrl} target="_blank" rel="noreferrer" className="btn btn-outline-accent">
                WhatsApp Now
              </a>
            </div>

            <div className="sidebar-panel sidebar-panel-soft">
              <h3>Browse more</h3>
              <div className="sidebar-links">
                {services
                  .filter((item) => item.id !== service.id)
                  .slice(0, 4)
                  .map((item) => (
                    <Link key={item.id} to={`/services/${item.id}`}>
                      {item.title}
                    </Link>
                  ))}
              </div>
            </div>
          </aside>
        </div>
      </section>

      {showModal && <QuoteModal onClose={() => setShowModal(false)} />}
    </>
  );
}
